// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"c16b7d47","357":"9547bbc7","443":"a387f545","548":"70abb653","797":"7a2daeb5","936":"2428b0e8"}[chunkId] + ".chunk.js";
};